// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"baacb3fb","879":"68310d0e"}[chunkId] + ".chunk.js";
};